import './front.scss';
import { SplitContentBlocksFront } from './SplitContentBlocksFront.js';

document.querySelectorAll( '[data-block="split-content-blocks"]' ).forEach( ( element ) => {
	new SplitContentBlocksFront( element );
} );
